// extracted by mini-css-extract-plugin
module.exports = {"card":"MediaLibrary_card__2dRUS","media":"MediaLibrary_media__2z5Km","header":"MediaLibrary_header__1salD","empty-state":"MediaLibrary_empty-state__2qVvf"};